import React from 'react'

export default () => {
  return (
    <>
      <h1 className="h3">Page Not Found</h1>
    </>
  )
}
